export default __webpack_public_path__ + "static/media/sparkles-3.130def1f.svg";